import {saveAnswer, loadAnswer} from './_someCrypto';
import {renderMath} from '../my_katex.js';

export class ProblemComponent {
    constructor(container, config, token, ansSaverFunc, need_answer_input, nosupport = false) {
        this.container = container;
        this.config = config;
        this.token = token;
        this.problemId = config.id;
        this.problemNum = config.order_index;
        this.inputElement = null;
        this.validationMessage = null;
        this.validationTimeout = null;
        this.ansSaverFunc = ansSaverFunc;
        this.need_answer_input = need_answer_input;
        this.nosupport = nosupport;
        this.init();
    }

    /**
     * Инициализация компонента: рендер, загрузка сохранённого ответа, навешивание обработчиков.
     */
    async init() {
        this.render();
        // await this.loadSavedAnswer();
        this.attachEventListeners();
        await this.initSupportChat();
    }

    /**
     * Рендерит HTML структуру задачи и добавляет её в конец контейнера.
     */
    render() {
        const problemElement = document.createElement("section");
        problemElement.id = `problem_${this.problemNum}`;
        problemElement.className = "problem-container";
        problemElement.innerHTML = `
        <div class="problem-text">
            <div class="clear-both"></div>
            <div class="prob-header-row">
            <span class="problem-title">Question ${this.problemNum}.</span> <span class="problem-name">${this.config.title_snapshot || ''}</span>
            </div>
            <p>
            ${this.config.html_text_snapshot}
            </p>
            <div class="clear-both"></div>
        </div>
        <div class="answer-input">
            <p class="validation-message">${this.config.expected_message_snapshot}</p>
            <input type="text" 
                   class="problem-input" 
                   placeholder="${this.config.placeholder_snapshot}" 
                   data-validation="${this.config.validation_regex_snapshot}">
            <span class="save-indicator hidden-ind">Saved!</span>
            <span class="save-indicator-error hidden-ind">Network error! Your answer wasn't saved. Please modify the field to retry.</span>
        </div>
        <div class="problem-chat-container"></div>
        `;

        this.container.appendChild(problemElement);
        renderMath(this.container);

        this.inputElement = problemElement.querySelector(".problem-input");
        this.answerInput = problemElement.querySelector(".answer-input");
        this.validationMessage = problemElement.querySelector(".validation-message");
        this.saveIndicator = problemElement.querySelector(".save-indicator");
        this.saveIndicatorError = problemElement.querySelector(".save-indicator-error");
        this.problem_chat_container = problemElement.querySelector(".problem-chat-container");
        if (this.config.student_answer) {
            this.inputElement.value = this.config.student_answer;
            this.saveIndicator.classList.remove("hidden-ind");
        }
        if (!this.need_answer_input) {
            this.answerInput.style.display = "none";
        }
    }

    async initSupportChat() {
        if (this.nosupport || !this.problem_chat_container) {
            return;
        }
        const {ProblemChat} = await import('./_problemChat.js');
        this.problem_chat_component = new ProblemChat(this.problem_chat_container, this.token, this.problemId);
    }


    /**
     * Загружает сохранённый ответ из localStorage (шифрованный).
     */
    async loadSavedAnswer() {
        const savedAnswer = await loadAnswer(this.problemId, this.token);
        if (savedAnswer) {
            this.inputElement.value = savedAnswer;
        }
    }

    /**
     * Навешивает обработчик событий для поля ввода.
     */
    attachEventListeners() {
        this.inputElement.addEventListener("input", this.handleInputChange.bind(this));
    }

    /**
     * Обрабатывает изменения в поле ввода с задержкой валидации.
     */
    handleInputChange() {
        this.saveIndicator.classList.add("hidden-ind");
        this.saveIndicatorError.classList.add("hidden-ind");
        clearTimeout(this.validationTimeout);
        this.clearValidationState();
        this.validationTimeout = setTimeout(this.validateInput.bind(this), 1000);
    }

    /**
     * Проверяет корректность введённого ответа и сохраняет его.
     */
    async validateInput() {
        const answer = this.inputElement.value.trim();
        const hasAnswer = answer.length > 0;
        const isValid = hasAnswer && this.checkValidation(answer);
        await saveAnswer(this.problemId, this.token, answer);

        if (!isValid && hasAnswer) {
            this.showValidationError();
            const res = await this.ansSaverFunc(answer, this.problemId, true);
        } else if (isValid) {
            this.showValidationSuccess();
            let res = undefined;
            try {
                res = await this.ansSaverFunc(answer, this.problemId);
            } catch (e) {
                console.error(e);
            }
            if (res?.status === "success") {
                this.saveIndicator.classList.remove("hidden-ind");
                // setTimeout(() => {
                //     this.saveIndicator.classList.add("hidden-ind");
                // }, 2000);
            } else {
                this.saveIndicatorError.classList.remove("hidden-ind");
                // setTimeout(() => {
                //     this.saveIndicatorError.classList.add("hidden-ind");
                // }, 2000);
            }
        } else {
            this.clearValidationState();
        }

    }

    /**
     * Проверяет ответ по регулярному выражению.
     */
    checkValidation(answer) {
        const pattern = this.inputElement.dataset.validation;
        if (!pattern) {
            return true;
        }
        try {
            const regex = new RegExp('^' + pattern + '$');
            return regex.test(answer.trim());
        } catch (e) {
            console.error('Invalid validation regex', pattern, e);
            return false;
        }
    }

    /**
     * Показывает ошибку валидации.
     */
    showValidationError() {
        this.validationMessage.classList.add("text-red-600");
        this.inputElement.classList.remove("border-green-600");
        this.inputElement.classList.add("border-red-600");
    }

    /**
     * Показывает успех валидации.
     */
    showValidationSuccess() {
        this.validationMessage.classList.remove("text-red-600");
        this.inputElement.classList.remove("border-red-600");
        this.inputElement.classList.add("border-green-600");
    }

    /**
     * Убирает классы ошибок перед повторной проверкой.
     */
    clearValidationState() {
        this.validationMessage.classList.remove("text-red-600");
        this.inputElement.classList.remove("text-red-600", "border-red-600", "border-green-600");
    }
}
